import * as React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

function easyRoom({color, ...props}: IconProps) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6.67857 10.1328C6.67857 10.2159 6.69362 10.2987 6.72772 10.3745C7.18781 11.3972 8.21871 12.1214 9.45055 12.1214C10.3942 12.1214 11.2396 11.6842 11.7704 11.019H15.0339C14.2475 13.1669 12.0456 14.7066 9.45055 14.7066C6.18709 14.7066 3.57031 12.4848 3.57031 10.1328H6.67857Z"
                fill={color || "white"}
            />
            <path
                d="M9.69654 2.28125H9.08038C8.96695 2.28125 8.875 2.37016 8.875 2.47984V3.27419C8.875 3.38386 8.96695 3.47277 9.08038 3.47277H9.69654C9.80997 3.47277 9.90192 3.38386 9.90192 3.27419V2.47984C9.90192 2.37016 9.80997 2.28125 9.69654 2.28125Z"
                fill={color || "white"}
            />
            <path
                d="M10.5699 1.88281H8.21401C8.01383 1.88281 7.85156 2.06063 7.85156 2.27999C7.85156 2.49934 8.01383 2.67716 8.21401 2.67716H10.5699C10.7701 2.67716 10.9323 2.49934 10.9323 2.27999C10.9323 2.06063 10.7701 1.88281 10.5699 1.88281Z"
                fill={color || "white"}
            />
            <path
                d="M9.43243 3.27344C12.6959 3.27344 15.3303 5.70651 15.3303 8.70985C15.3303 9.05199 15.291 9.37514 15.232 9.69828H6.66044H3.60495C3.60495 9.69828 3.46616 9.79522 3.53458 8.70985C3.72357 5.71207 6.16896 3.27344 9.43243 3.27344ZM6.66044 7.7214H12.2044C11.7719 6.63793 10.6906 5.85859 9.43243 5.85859C8.15457 5.85859 7.09295 6.63793 6.66044 7.7214Z"
                fill={color || "white"}
            />
            <path
                d="M4.6204 2.32038C4.52357 2.12517 4.28816 2.04155 4.09612 2.14452C3.27473 2.58498 2.55753 3.18911 1.99294 3.91847C1.43572 4.63832 1.04144 5.46169 0.833678 6.33497C0.780506 6.55847 0.935968 6.77302 1.16291 6.80875C1.38645 6.84395 1.5951 6.69212 1.64919 6.47239C1.83371 5.7229 2.17536 5.01639 2.6546 4.39728C3.13509 3.77656 3.74176 3.25938 4.43573 2.87662C4.63376 2.7674 4.72089 2.52297 4.6204 2.32038Z"
                fill={color || "white"}
            />
            <path
                d="M5.06143 3.53664C4.94031 3.35541 4.69626 3.30216 4.51847 3.42829C3.50648 4.14627 2.72481 5.12615 2.26356 6.25435C2.17628 6.46784 2.2985 6.70449 2.51872 6.77305C2.7329 6.83974 2.9596 6.72201 3.04583 6.51493C3.44234 5.56277 4.10009 4.73298 4.94789 4.11532C5.1319 3.98126 5.18794 3.72592 5.06143 3.53664Z"
                fill={color || "white"}
            />
        </svg>
    )
}

export default easyRoom
